import { getEncode } from '@/lib/mix'
import { setCodeData, debounce } from '@/lib/utils'
import { isMobile } from '@/lib/device'
import { mapState, mapActions, mapMutations } from 'vuex'
import { getAssignUseField } from '@/services/inqueryServices'

export default {
  data () {
    return {
      assignUseField: [],
      assignRelateParams: {},
      recycleRuleParams: {}
    }
  },
  computed: {
    ...mapState('inquery/detailData', [
      'isBeiAn',
      'isDeal',
      'formError',
      'repeatSaveItems'
    ]),
    ...mapState('inquery/relateData', [
      'isInfoSign',
      'isInvalid',
      'isDiscard'
    ]),

    isAuditPage () {
      return this.$route.name === 'InqueryDetail' && this.auditStatus !== 1
    },
    isCreatePage () {
      return this.$route.name === 'InqueryCreate'
    },
    isPassPage () {
      return (this.$route.name === 'InqueryDetail' && this.auditStatus === 1) || this.$route.name === 'InqueryPassDetail'
    },
    isClue () {
      return this.$route.name === 'ClueCreate' || this.$route.name === 'ClueDetail'
    }
  },
  watch: {
    isBeiAn: {
      async handler (val) {
        // 进入录入/审核页面时，没有选择备案
        if ((this.isAuditPage || this.isCreatePage) && !this.isBeiAn) {
          await this.fetchAssignUseField()
        }
        // 进入录入页面，选择了备案，进入审核页面不默认发请求，为了不覆盖审核页面原来选择的值
        if (this.isCreatePage && this.isBeiAn) {
          this.followUsers(this)
        }
      },
      immediate: true
    },
    /* 是否选择成交 */
    isDeal: {
      handler  (val) {
        if (!this.formData || !this.formData.deal_info) return
        this.$set(this.formData.deal_info, 'show', val)
      },
      immediate: true
    },
    /* 是否选择了丢单 */
    isDiscard: {
      handler  (val) {
        if (!this.formData || !this.formData.discard_info) return
        this.$set(this.formData.discard_info, 'show', val)
      },
      immediate: true
    },
    /* 是否选择了无效 */
    isInvalid: {
      handler  (val) {
        if (!this.formData || !this.formData.invalid_info) return
        this.$set(this.formData.invalid_info, 'show', val)
      },
      immediate: true
    }
  },
  async created () {
    this.setFooterStyle()
    window.addEventListener('resize', this.setFooterStyle)
    document.addEventListener('scroll', this.setFooterStyle)
    // 详情页面状态是审核
    /* if ((this.isAuditPage || this.isCreatePage) && !this.isBeiAn) {
      await this.fetchAssignUseField()
    } */
    if (this.isPassPage) {
      let { formData = {} } = this
      let { base_info: baseInfo = {} } = formData
      let { child = [] } = baseInfo
      child.forEach(item => {
        let { fieldtype, fieldkey, fieldvalue } = item
        if (fieldtype === 'radioinfo_level' || fieldtype === 'radioinfo_type' || fieldtype === 'radioinfo_followup') {
          if (fieldvalue) {
            this.recycleRuleParams[fieldkey] = fieldvalue
          }
        }
      })

      this.getRecycleRuleTips(this.recycleRuleParams, this)
    }

    this.$bus.$on('handleChangeBeian', this.handleChangeBeian)
  },

  destroyed () {
    // 清空分配关联人员列表
    this.SET_ASSIGN_LIST_DATA([])
    // 清空来源关联人员列表
    this.SET_RELATE_LIST_DATA([])
    this.UPDATE_IS_DEAL(false)
    this.updataIsBeiAn(false)
    // 是否选择无效，状态重置为false
    this.UPDATE_IS_INVALID(false)
    // 是否选择丢单，状态重置为false
    this.UPDATE_IS_DISCARD(false)
    // 清空回收规则提示
    this.SET_RECYCLE_TIPS('')
    // 清空已回收提示
    this.SET_RECYCLE_LOG_TIPS('')
    this.$bus.$off('handleChangeBeian')
  },
  methods: {
    ...mapActions('inquery/relateData', [
      'fetchRelateTeamInfo',
      'fetchAssignTeamInfo',
      'fetchFollowUsers',
      'fetchRecycleRuleTips'
    ]),
    ...mapMutations('inquery/relateData', [
      'SET_RELATE_LIST_DATA',
      'SET_ASSIGN_LIST_DATA',
      'SET_RECYCLE_TIPS',
      'SET_RECYCLE_LOG_TIPS',
      'UPDATE_IS_INVALID',
      'UPDATE_IS_DISCARD'
    ]),
    ...mapMutations('inquery/detailData', [
      'updataIsBeiAn',
      'UPDATE_IS_DEAL'
    ]),

    /* 录入和审核页面，进入页面，请求关联接口，获取关联人员 */
    initFromInfo () {
      const { from_info: fromInfo, info: userInfo } = this.formData || {}
      const { fieldvalue = '', child = [] } = fromInfo || {}
      if (fieldvalue) {
        let currentItem = child.find(one => one.fieldkey === fieldvalue) || {}
        this.currentFrom = currentItem.id
      } else {
        this.currentFrom = undefined
      }
      if (this.currentFrom) {
        this.formData['from_info'].fieldvalue = this.currentFrom
      }

      // 请求关联人员
      if (fromInfo && userInfo && userInfo.child && this.isCreatePage) {
        for (let item of userInfo.child) {
          // 如果开发人员，没有选择值时，直接请求关联接口
          // （字段默认必填，审核页面，如果 userid 为 0，可以认为是选了 -无- ）
          // 所以只有录入页面，userid 没值时，才请求关联接口
          if (
            item.fieldkey === 'dev' &&
            item.fieldtype === 'cascader' &&
            (!item.info || !item.info.userid || this.$route.query.clue_id)
          ) {
            this.relateTeamInfo(fromInfo)

            break
          }
        }
      }
    },
    /**
     * 切换备案状态时
     *  */
    handleChangeBeian (val) {
      // 详情页面状态是审核，或者是录入页面
      if (this.isBeiAn) {
        if (this.isCreatePage || this.isAuditPage) {
          this.formData.info.child && this.formData.info.child.forEach(item => {
            if (item.fieldkey === 'dev') {
              item.fieldvalue = isMobile ? [{ keyname: 'roleid',
                id: 'null',
                name: '-无-' }] : ['null-roleid']
              item.info = {
                roleid: 'null'
              }
              item.isBeiAn = true
            }
          })
        }

        this.followUsers(this)
      } else { // 清空关联数据
        this.SET_ASSIGN_LIST_DATA([])
      }
    },
    /**
     * 操作表单的某一项，获取结果
     * @param {*} val 移动端返回的是item, pc端返回的是 fieldvalue
     * @param {*} item
     */
    handleChangeItem (val, item) {
      let { fieldtype } = item || {}
      // 如果富文本失去焦点，会执行这里，影响跟进人员，所以禁止掉
      if (fieldtype === 'editor') return

      if (this.isAuditPage || this.isCreatePage) {
        this.handleAssignRelate(item)
      } else { // 通过详情页
        this.handleRuleTips(item)
      }
    },
    /**
     * 根据分配规则，关联跟进人员
     * @param {*} item
     */
    handleAssignRelate (item) {
      if (!this.isBeiAn) {
        for (let key in this.assignRelateParams) {
          if (item.fieldkey === key) {
            this.assignRelateParams[item.fieldkey] = item.fieldvalue
            if (item.fieldtype === 'area') {
              let { fieldvalue = {} } = item
              let { code = {} } = fieldvalue
              this.assignRelateParams[item.fieldkey] = Object.keys(code)
            }
          }
        }

        // 请求信息分配配置接口，覆盖已选择的跟进人员
        if (Object.keys(this.assignRelateParams).includes(item.fieldkey)) {
          this.assignTeamInfo(this.assignRelateParams, this)
        }
      }
    },
    /**
     * 基础信息模块回收提示
      */
    handleRuleTips (item = {}) {
      let { fieldtype, fieldkey, fieldvalue } = item
      if (fieldtype === 'radioinfo_level' || fieldtype === 'radioinfo_type' || fieldtype === 'radioinfo_followup') {
        if (fieldvalue) {
          this.recycleRuleParams[fieldkey] = fieldvalue
        }

        this.getRecycleRuleTips(this.recycleRuleParams, this)
      }
    },

    /**
     * 人员信息某一项更改，更新this.formData.info下的child的数据
     * @param {object} data 人员信息的每一项的数据
     */
    handleChangeMember (data = {}) {
      if (!this.formData || !this.formData.info || !this.formData.info.child) {
        return
      }

      for (let i in this.formData.info.child) {
        const { fieldkey } = data
        const item = this.formData.info.child[i]
        if (fieldkey === item.fieldkey) {
          this.formData.info.child.splice(i, 1, data)
        }
      }
      this.$forceUpdate()
    },
    /**
     * pc 端
     * 提交询盘时，校验错误，跳转到错误地方
     * @param {Object} err
     */
    checkError (err) {
      /* if (Object.keys(this.formError).length) {
        err = Object.assign({}, err, this.formError)
      } */
      if (err && Object.keys(err).length > 0) {
        // 删除隐藏的必填字段的验证
        this.deleteVisibleErrorItem((item = {}) => {
          if (item.fieldkey in err) {
            delete err[item.fieldkey]
          }
        })
        // 删除重复可编辑字段的校验结果
        for (let fieldkey in err) {
          for (let k in this.repeatSaveItems) {
            if (fieldkey === k && this.repeatSaveItems[k] === 1) {
              delete err[fieldkey]
            }
          }
        }
        // 验证不通过的字段点击保存时滚动到报错的位置
        if (Object.keys(err).length > 0) {
          const domId = document.getElementById(Object.keys(err)[0])
          domId.scrollIntoView()
          let distance = document.documentElement.scrollTop || document.body.scrollTop
          document.documentElement.scrollTop = distance - 100
          document.body.scrollTop = distance - 100
        } else {
          err = null
        }
        return err
      }
    },
    /**
     * 移动端校验
     */
    validateResult () {
      let _this = this
      const keys = Object.keys(this.$refs).filter(key => key.indexOf('item_') === 0)
      const { length } = keys
      let hasError = false
      this.errorElements = []
      let asyncValid = true
      return new Promise(async (resolve, reject) => {
        for (let i = 0; i < length; i++) {
          const id = keys[i]
          const ref = _this.$refs[id][0]
          if (ref && ref.validate) {
            ref.validate((result) => {
              // TODO: 异步校验
              let { fieldtype, isrepeatsave } = ref.data || {}

              // 删除隐藏的必填字段的验证
              this.deleteVisibleErrorItem((item = {}) => {
                if (item.fieldkey === ref.data.fieldkey) {
                  result = true
                }
              })

              if (result === false) {
                if (!isrepeatsave) {
                  hasError = true
                }
                _this.errorElements.push(ref.$el)
              }
              // 邮箱和电话的校验结果是异步，数据返回来有延迟
              if (fieldtype === 'email' || fieldtype === 'phone') {
                asyncValid = asyncValid && ref.data.valid
                if (!asyncValid) {
                  if (!isrepeatsave) {
                    hasError = true
                  }
                  _this.errorElements.push(ref.$el)
                }
              }
            })
          } else {
            hasError = false
          }
        }
        resolve(hasError)
      })
    },

    /**
     * 删除隐藏的必填字段的验证
     */
    deleteVisibleErrorItem (callback) {
      let arr = ['deal_info', 'discard_info', 'invalid_info']
      arr.forEach(k => {
        if (this.formData && this.formData[k] && this.formData[k].child) {
          // 如果成交/无效/丢单隐藏时，删除子项校验不通过的信息
          if (!this.formData[k].show) {
            this.formData[k].child.forEach(item => {
              callback && callback(item)
            })
          }
        }
      })
    },

    /**
     * 询盘详情，提交表单，参数转换成键值对格式，并加密
     * @param {Object} data // formData
     */
    async setFormDataParams (data) {
      const enCode = await getEncode()
      let newData = {}

      for (let k in data) {
        let modules = data[k]
        if (!modules) return

        newData[k] = {}
        modules.children = modules.child || []
        // 特殊处理来源和信息模块数据
        if (k === 'base_info') {
          modules.children.forEach(child => {
            if (child.fieldtype === 'radioinfo_type') {
              newData['base_info']['info_sign'] = this.isBeiAn ? 1 : 0
            }
          })
        } else if (k === 'from_info') {
          let { fieldvalue = '', childObj = {} } = modules
          if (fieldvalue) {
            newData[k].from = childObj[fieldvalue] && childObj[fieldvalue].fieldkey
            // if (!this.isClue) {
            //   modules.children = childObj[fieldvalue] && childObj[fieldvalue].child
            // }
            const { child = [] } = childObj[fieldvalue]
            modules.children = childObj[fieldvalue] && child
            // modules.children = childObj[fieldvalue] && childObj[fieldvalue].child
          } else {
            newData[k].from = this.isClue ? '' : (modules.children[0] && modules.children[0].fieldkey)
            // const { fieldkey = '' } = modules.children[0]
            // newData[k].from = modules.children[0] && fieldkey
          }
        } else if (
          k === 'info' &&
          modules &&
          modules.child &&
          modules.child.length
        ) {
          if (
            !this.inquiryId ||
            (this.inquiryId &&
              (this.from === 'audit' ||
                this.auditStatus === 0 ||
                this.auditStatus === -1))
          ) {
            // 录入，审核详情
            for (let item of modules.child) {
              let key = ''
              switch (item.fieldkey) {
                case 'group':
                  if (this.auditStatus === 0 || this.auditStatus === -1) {
                    // 审核详情
                    key = 'audit'
                  } else if (this.isClue) {
                    // 录入页面
                    key = 'input'
                  } else if (!this.inquiryId) {
                    // 录入页面
                    key = 'input'
                  }
                  break
                case 'dev':
                case 'follow':
                case 'input':
                  key = item.fieldkey
                  break
              }
              const { info = {} } = item
              if (key) {
                newData[k][key + '_userid'] = info.userid
                newData[k][key + '_groupid'] = info.groupid
                newData[k][key + '_roleid'] = info.roleid
                if (key === 'follow' && info.divide_type) {
                  newData[k].divide_type = info.divide_type
                }
                if (key === 'dev' && (info.roleid === 'null' || (info.userid === 0 && (this.isCreatePage || this.isAuditPage)))) {
                  newData[k][key + '_userid'] = -1
                }
              }
            }
          }
          newData[k].is_shared = modules.is_shared ? 1 : 0
          continue
        }
        for (let item of modules.children) {
          const value = item.fieldvalue

          const { input = '', address = '', code = {}, treedata = [] } =
            value || {}
          // 加密处理
          // text,editor,area.input,select_tree.input,tag.*,number,email.*,phone.*
          switch (item.fieldtype) {
            case 'text':
            case 'phone':
            case 'email':
            case 'editor':
            case 'tag':
              newData[k][item.fieldkey] = await setCodeData(value, enCode)
              if (item.fieldtype === 'text') {
                newData[k][item.fieldkey] = newData[k][item.fieldkey].trim()
              }
              break
            case 'area':
              newData[k][item.fieldkey] = newData[k][item.fieldkey] || {}
              newData[k][item.fieldkey].code = Object.keys(code)
              newData[k][item.fieldkey].address = await setCodeData(
                address,
                enCode
              )
              newData[k][item.fieldkey].address = newData[k][item.fieldkey].address.trim()
              break
            case 'select_tree':
              newData[k][item.fieldkey] = newData[k][item.fieldkey] || {}
              newData[k][item.fieldkey].treedata = treedata
              newData[k][item.fieldkey].input = await setCodeData(input, enCode)
              newData[k][item.fieldkey].input = newData[k][item.fieldkey].input.trim()
              break
            case 'select_reception':
              if (!Array.isArray(value) && value === '- -') {
                newData[k][item.fieldkey] = []
              } else {
                newData[k][item.fieldkey] = value
              }
              break
            default:
              newData[k][item.fieldkey] = value
              break
          }
        }
      }
      if (this.$route.name === 'InqueryPassDetail' || (this.auditStatus === 1 && this.$route.name === 'InqueryDetail')) {
        delete newData.reception_info
      }
      return newData
    },

    async relateTeamInfo (modulesData) {
      // 关联人员
      const { currentFrom = '' } = this
      const { fieldkey = '', childObj = {} } = modulesData

      if (fieldkey === 'from_info' && childObj[currentFrom]) {
        const { fieldkey = '', child: childData = {} } = childObj[currentFrom]
        let params = {}
        params.fieldkey = fieldkey
        params.fromkv = {}

        for (let item of childData) {
          params.fromkv[item.fieldkey] = item.fieldvalue || ''
        }

        try {
          let chain = await this.fetchRelateTeamInfo()
          chain.params(params).fetch()
        } catch (error) {
          console.log(error)
        }
      }
    },

    /**
     * 关联跟进人员
     */
    assignTeamInfo: debounce(async (params, _this) => {
      try {
        let chain = await _this.fetchAssignTeamInfo()
        chain
          .params(params)
          .fetch()
      } catch (error) {
        console.log(error)
      }
    }, 1000),

    followUsers: debounce(async (_this) => {
      try {
        let chain = await _this.fetchFollowUsers()
        chain
          .params()
          .fetch()
      } catch (error) {
        console.log(error)
      }
    }, 1000),

    getRecycleRuleTips: debounce(async (params, _this) => {
      try {
        let chain = await _this.fetchRecycleRuleTips()
        chain
          .params({ rule: params, inquiryid: _this.inquiryId })
          .fetch()
      } catch (error) {
        console.log(error)
      }
    }, 1000),

    // 审核页面
    async fetchAssignUseField () {
      let chain = await getAssignUseField()
      chain
        .params()
        .onSuccess(res => {
          this.assignUseField = res.select

          let formDataArr = []
          for (let k in this.formData) {
            let modules = this.formData[k]
            if (modules.child && modules.child.length) {
              formDataArr.push(...modules.child)
            }
          }

          this.assignUseField.forEach(field => {
            formDataArr.forEach(item => {
              if (field.fieldkey === item.fieldkey) {
                if (item.fieldtype === 'area') {
                  let { fieldvalue = {} } = item
                  let { code = {} } = fieldvalue
                  this.assignRelateParams[field.fieldkey] = Object.keys(code)
                } else {
                  this.assignRelateParams[field.fieldkey] = item.fieldvalue
                }
              }
            })
          })
          if (this.isCreatePage) {
            this.assignTeamInfo(this.assignRelateParams, this)
          }
        })
        .fetch()
    },

    /**
     * 设置表单底部按钮定位
     */
    setFooterStyle () {
      this.$nextTick(() => {
        if (!this.$refs.footer || isMobile) return

        const $footer = this.$refs.footer

        $footer.style.width = $footer.parentNode.offsetWidth + 40 * 2 + 'px'
        // console.log($footer.parentNode.offsetWidth)
        // 44 是页面底部的高度
        const sectionWidth = this.$getSectionWidth()
        const pageWidth = this.$getPageSize().pageWidth
        const windowHeight = window.innerHeight || document.documentElement.clientHeight
        if (
          $footer.parentNode.offsetTop -
            this.$getScrollTop() -
            windowHeight +
            $footer.parentNode.offsetHeight +
            44 <
          0
        ) {
          $footer.style.position = 'relative'
          $footer.style.left = 0
        } else {
          $footer.style.position = 'fixed'
          $footer.style.left =
            pageWidth <= sectionWidth
              ? $footer.parentNode.offsetLeft + 'px'
              : $footer.parentNode.offsetLeft +
                (pageWidth - sectionWidth) / 2 +
                'px'
        }
      })
    }
  }
}
